import React, { Component } from 'react';
import { arrayOf, bool, func, string } from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';

import { useRouteConfiguration } from '../../context/routeConfigurationContext';

import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import { ensureCurrentUser } from '../../util/data';
import { propTypes } from '../../util/types';
import { createResourceLocatorString, pathByRouteName } from '../../util/routes';

import { Modal } from '../../components';

import EmailReminder from './EmailReminder';
import EarlySignupForm from './EarlySignupForm';

import StripeAccountReminder from './StripeAccountReminder';
import css from './ModalMissingInformation.module.css';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import routeConfiguration from '../../routing/routeConfiguration';

const MISSING_INFORMATION_MODAL_WHITELIST = [
  'LoginPage',
  'SignupPage',
  'ContactDetailsPage',
  'EmailVerificationPage',
  'PasswordResetPage',
  'StripePayoutPage',
];

const EMAIL_VERIFICATION = 'EMAIL_VERIFICATION';
const STRIPE_ACCOUNT = 'STRIPE_ACCOUNT';
const EARLY_SIGNUP = 'EARLY_SIGNUP';

const USERNAME = process.env.REACT_APP_AUTH_USERNAME;
const PASSWORD = process.env.REACT_APP_AUTH_PASSWORD;

class ModalMissingInformation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showMissingInformationReminder: null,
      hasSeenMissingInformationReminder: false,
      mailRequest: false,
      mailInProgress: false
    };
    this.handleMissingInformationReminder = this.handleMissingInformationReminder.bind(this);
  }

  componentDidUpdate() {
    const { currentUser, currentUserHasListings, currentUserHasOrders, location } = this.props;
    const user = ensureCurrentUser(currentUser);
    this.handleMissingInformationReminder(
      user,
      currentUserHasListings,
      currentUserHasOrders,
      location
    );
  }

  handleMissingInformationReminder(
    currentUser,
    currentUserHasListings,
    currentUserHasOrders,
    newLocation
  ) {
    const routes = this.props.routeConfiguration;
    const whitelistedPaths = MISSING_INFORMATION_MODAL_WHITELIST.map(page =>
      pathByRouteName(page, routes)
    );

    // Is the current page whitelisted?
    const isPageWhitelisted = whitelistedPaths.includes(newLocation.pathname);

    // Track if path changes inside Page level component
    const pathChanged = newLocation.pathname !== this.props.location.pathname;
    const notRemindedYet =
      !this.state.showMissingInformationReminder && !this.state.hasSeenMissingInformationReminder;

    // Is the reminder already shown on current page
    const showOnPathChange = notRemindedYet || pathChanged;
    const earlyAuth = typeof window != 'undefined' && window.localStorage.getItem('earlyAuth');
    const parsedAuth = (earlyAuth && JSON.parse(earlyAuth)) || {};

    if (!isPageWhitelisted && showOnPathChange) {
      // Emails are sent when order is initiated
      // Customer is likely to get email soon when she books something
      // Provider email should work - she should get an email when someone books a listing
      // const hasOrders = currentUserHasOrders === true;
      // const hasListingsOrOrders = currentUserHasListings || hasOrders;

      const emailUnverified = !!currentUser.id && !currentUser.attributes.emailVerified;// && currentUser.attributes.profile.publicData && currentUser.attributes.profile.publicData.completeStep1;
      const emailVerificationNeeded = emailUnverified; //hasListingsOrOrders && 

      // const stripeAccountMissing = !!currentUser.id && !currentUser.attributes.stripeConnected;
      // const stripeAccountNeeded = currentUserHasListings && stripeAccountMissing;

      // Show reminder
      if (emailVerificationNeeded) {
        this.setState({ showMissingInformationReminder: EMAIL_VERIFICATION });
      } 
      // else if (!(parsedAuth && Object.keys(parsedAuth).length) || (parsedAuth && parsedAuth.user && parsedAuth.pass && parsedAuth.user != USERNAME && parsedAuth.pass != PASSWORD)) {
      //   this.setState({ showMissingInformationReminder: EARLY_SIGNUP });
      // }
      //  else if (stripeAccountNeeded) {
      //   this.setState({ showMissingInformationReminder: STRIPE_ACCOUNT });
      // }
    }
  }

  render() {
    const {
      rootClassName,
      className,
      containerClassName,
      currentUser,
      submitLogin,
      sendVerificationEmailInProgress,
      sendVerificationEmailError,
      onManageDisableScrolling,
      onResendVerificationEmail,
      earlyAccess,
      history
    } = this.props;
    const user = ensureCurrentUser(currentUser);
    const classes = classNames(rootClassName || css.root, className);
    const earlyAuth = typeof window != 'undefined' && window.localStorage.getItem('earlyAuth');
    const parsedAuth = (earlyAuth && JSON.parse(earlyAuth)) || {};
    let content = null;

    const currentUserLoaded = user && user.id;
    // if (!(parsedAuth && Object.keys(parsedAuth).length) || (parsedAuth && parsedAuth.user && parsedAuth.pass && parsedAuth.user != USERNAME && parsedAuth.pass != PASSWORD)) {
    //   content = (
    //     <EarlySignupForm
    //       onSubmit={values => {
    //         const { email, password } = values;
    //         typeof window != 'undefined' && window.localStorage.setItem('earlyAuth', JSON.stringify({
    //           user: email,
    //           pass: password
    //         }))
    //         this.setState({ showMissingInformationReminder: false });
    //         return history.push(createResourceLocatorString('SignupPage', routeConfiguration(), {}, {}))
    //       }}
    //       mailRequest={this.state.mailRequest}
    //       isMailPending = {this.state.mailInProgress}
    //       onSubmitThroughtRequest={(values)=>{
    //         this.setState({mailInProgress: true})
    //         const {emailId} = values;
    //         earlyAccess(emailId).then((res)=>{
    //           this.setState({mailRequest: true,mailInProgress: false})
    //         })
    //       }}
    //     />
    //   );
    // } else 
    if (currentUserLoaded) {
      if (this.state.showMissingInformationReminder === EMAIL_VERIFICATION) {
        content = (
          <EmailReminder
            className={classes}
            user={user}
            onResendVerificationEmail={onResendVerificationEmail}
            sendVerificationEmailInProgress={sendVerificationEmailInProgress}
            sendVerificationEmailError={sendVerificationEmailError}
          />
        );
      } else if (this.state.showMissingInformationReminder === STRIPE_ACCOUNT) {
        content = <StripeAccountReminder className={classes} />;
      }
    }

    const closeButtonMessage = (
      <FormattedMessage id="ModalMissingInformation.closeVerifyEmailReminder" />
    );

    return (
      <Modal
        id="MissingInformationReminder"
        containerClassName={containerClassName}
        isOpen={!!this.state.showMissingInformationReminder}
        onClose={() => {
          this.setState({
            showMissingInformationReminder: null,
            hasSeenMissingInformationReminder: true,
          });
        }}
        usePortal
        showCloseButton={false}
        onManageDisableScrolling={onManageDisableScrolling}
        closeButtonMessage={closeButtonMessage}
        hideCloseButton={this.state.showMissingInformationReminder == EARLY_SIGNUP}
      >
        {content}
      </Modal>
    );
  }
}

ModalMissingInformation.defaultProps = {
  className: null,
  rootClassName: null,
  currentUser: null,
};

ModalMissingInformation.propTypes = {
  id: string.isRequired,
  className: string,
  rootClassName: string,
  containerClassName: string,

  currentUser: propTypes.currentUser,
  onManageDisableScrolling: func.isRequired,
  sendVerificationEmailError: propTypes.error,
  sendVerificationEmailInProgress: bool.isRequired,

  // from useRouteConfiguration
  routeConfiguration: arrayOf(propTypes.route).isRequired,
};

const EnhancedModalMissingInformation = props => {
  const routeConfiguration = useRouteConfiguration();

  return <ModalMissingInformation routeConfiguration={routeConfiguration} {...props} />;
};

export default EnhancedModalMissingInformation;
